// Module
var code = "<!DOCTYPE html> <html lang=\"ja\"> <head> <meta charset=\"UTF-8\"> <meta name=\"viewport\" content=\"width=device-width,initial-scale=1\"> <title>cashb|印刷ページ</title> </head> <body> <div id=\"content\"></div> </body> </html> ";
// Exports
export default code;